// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main {\n  width: 100%;\n  height: 100%;\n}\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 24px;\n  border-bottom: 1px #EBEEF5 solid;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
